import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrintLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import PN from "persian-number";


const PrintPaymentReceivedIndex = () => {

    //#region Const
    const navigate = useNavigate();
    const GetTaxRef = useRef()
    const toaster = rsuite.useToaster();

    const [FiscalYearId, setFiscalYearId] = useState(-1);
    const [RNumber, setRNumber] = useState("");
    const [Comment, setComment] = useState("");
    const [PaymentList, setPaymentList] = useState([]);
    const [Acc_CTitle, setAcc_CTitle] = useState("");

    const [Sub_Acc_LTitle1, setSub_Acc_LTitle1] = useState("");
    const [Sub_Acc_L1, setSub_Acc_L1] = useState(-1);
    const [Sub_Acc_LTitle2, setSub_Acc_LTitle2] = useState("");
    const [Sub_Acc_L2, setSub_Acc_L2] = useState(-1);
    const [Sub_Acc_LTitle3, setSub_Acc_LTitle3] = useState("");
    const [Sub_Acc_L3, setSub_Acc_L3] = useState(-1);
    const [DOCSetting, setDOCSetting] = useState("");
    const [PaymentReceivedId, setPaymentReceivedId] = useState(localStorage.getItem("PaymentReceivedId") == null ? General.GuidEmpty() : localStorage.getItem("PaymentReceivedId"));
    ///  1 Fund 
    ///  2 POS
    ///  3 Kart to Kart
    ///  4 Havale
    ///  5 Personal check
    ///  6 Other check 
    ///  7 AccountTransfer
    const [TotalFundPayment, setTotalFundPayment] = useState(0);
    const [TotalHavalePayment, setTotalHavalePayment] = useState(0);
    const [TotalPersonalcheckPayment, setTotalPersonalcheckPayment] = useState(0);
    const [TotalcheckPayment, setTotalcheckPayment] = useState(0);
    const [TotalAccountTransferPayment, setTotalAccountTransferPayment] = useState(0);
    const [TotalPayment, setTotalPayment] = useState(0);
    const [PayDate, setPayDate] = useState("");
    const [PayTime, setPayTime] = useState("");

    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/PaymentReceived/GetHeaderById', {
                method: 'post',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': localStorage.getItem("PaymentReceivedId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    console.dir(result)
                    setRNumber(result.number);
                    setPayDate(result.payDate);
                    setPayTime(result.payTime);
                    setDOCSetting(result.docSetting)
                    setComment(result.comment == null ? "" : result.comment);
                    setAcc_CTitle(result.acc_CTitle);
                    setSub_Acc_L1(result.sub_Acc_L1);
                    setSub_Acc_LTitle1(result.sub_Acc_LTitle1);
                    setSub_Acc_L2(result.sub_Acc_L2);
                    setSub_Acc_LTitle2(result.sub_Acc_LTitle2);
                    setSub_Acc_L3(result.sub_Acc_L3);
                    setSub_Acc_LTitle3(result.sub_Acc_LTitle3);
                    setPaymentList(result.children);
                    setTotalFundPayment(result.children.filter(x => x.payType == 1).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalHavalePayment(result.children.filter(x => x.payType == 4).map(o => o.price * 1).reduce((a, b) => a + b, 0));
                    setTotalPersonalcheckPayment(result.children.filter(x => x.payType == 5).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalcheckPayment(result.children.filter(x => x.payType == 6).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalAccountTransferPayment(result.children.filter(x => x.payType == 7).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalPayment(result.children.map(o => o.price).reduce((a, b) => a + b, 0));

                })
        )
    }





    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 40);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetById();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = "چاپ رسید پرداخت  ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion



    return (

        <Layout title={" چاپ رسید پرداخت : " + DOCSetting}>


            <rsuite.Row className={localStorage.getItem("HeaderFontSize_PaymentPrint") + " p-1 "}>
                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b>شماره رسید :   </b>{RNumber}
                </rsuite.Col>
                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> تاریخ:   </b> {PayDate}

                </rsuite.Col>

                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> حساب معین:   </b> {Acc_CTitle}
                </rsuite.Col>
                <rsuite.Col className={Sub_Acc_L1 != -1 ? "" : "hide"} xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> تفصیلی 1:   </b> {Sub_Acc_LTitle1}
                </rsuite.Col>
                <rsuite.Col className={Sub_Acc_L2 != -1 ? "" : "hide"} xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> تفصیلی 2:   </b> {Sub_Acc_LTitle2}
                </rsuite.Col>
                <rsuite.Col className={Sub_Acc_L3 != -1 ? "" : "hide"} xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> تفصیلی 3: </b> {Sub_Acc_LTitle3}
                </rsuite.Col>
                <rsuite.Col className={Comment != "" ? "" : "hide"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <b> توضیحات:  </b> {Comment}
                </rsuite.Col>

            </rsuite.Row>
            <hr />

            <rsuite.Row className={localStorage.getItem("FinancialFontSize_PaymentPrint") + " p-1 "}>

                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>
                                    #
                                </th>
                                <th className='text-end'>
                                    نوع
                                </th>
                                <th className='text-center '>
                                    تاریخ - ساعت
                                </th>
                                {/* <th className='text-end'>
                                    شرح
                                </th> */}
                                <th className='text-start'>
                                    مبلغ (ریال)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {PaymentList.map((rowData, index) => (
                                <>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{rowData.payTypeComment}
                                            <br />
                                            <b>شرح : </b>
                                            <text className={rowData.payType == 1 ? "" : 'hide'}>
                                                صندوق : {rowData.fund}
                                            </text>
                                            <text className={rowData.payType == 4 ? "" : 'hide'}>
                                                بانک : {rowData.bankAccount}
                                                <text className={rowData.recieptNo != "" ? "" : 'hide'}> - شماره رسید : {rowData.recieptNo}  </text>
                                                <text className={rowData.destinationAccountNo != "" ? "" : 'hide'}> - شماره حساب مقصد : {rowData.destinationAccountNo}  </text>
                                            </text>
                                            <text className={rowData.payType == 5 ? "" : 'hide'}>
                                                بانک : {rowData.bankAccount}
                                                - سریال  : {rowData.checkNo}
                                                - سر رسید : {rowData.checkDate}
                                                <text className={rowData.byCheck != "" ? "" : 'hide'}> - در وجه  : {rowData.byCheck}  </text>
                                                - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - تایید نشده" : "صیادی - تایید شده"}
                                            </text>
                                            <text className={rowData.payType == 6 ? "" : 'hide'}>
                                                صادر کننده : {rowData.recieptItem_CheckBy}
                                                <text className={rowData.recieptItem_Bank != "" ? "" : 'hide'}> - بانک  : {rowData.recieptItem_Bank}  </text>
                                                <text className={rowData.recieptItem_Branch != "" ? "" : 'hide'}> - شعبه  : {rowData.recieptItem_Branch}  </text>

                                                - سریال  : {rowData.recieptItem_CheckNo}
                                                - سر رسید : {rowData.recieptItem_CheckDate}
                                                - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - منتقل نشده" : "صیادی - منتقل شده"}
                                            </text>
                                            <text className={rowData.payType == 7 ? "" : 'hide'}>
                                                انتقال حساب به  : {rowData.accountTransfer}
                                            </text>
                                            <small className={rowData.comment != "" ? "text-muted" : 'hide'}>
                                                <br />   توضیحات : {rowData.comment}
                                            </small>
                                        </td>
                                        <td className='text-center'>{rowData.payDate} - {rowData.payTime}  </td>

                                        <td className='text-start'>
                                            {PN.sliceNumber(rowData.price)}
                                        </td>
                                    </tr>
                                    {/* <tr >
                                        <td colSpan={3} className='text-end'>
                                            <b>شرح : </b>
                                            <text className={rowData.payType == 1 ? "" : 'hide'}>
                                                صندوق : {rowData.fund}
                                            </text>
                                            <text className={rowData.payType == 4 ? "" : 'hide'}>
                                                بانک : {rowData.bankAccount}
                                                <text className={rowData.recieptNo != "" ? "" : 'hide'}> - شماره رسید : {rowData.recieptNo}  </text>
                                                <text className={rowData.destinationAccountNo != "" ? "" : 'hide'}> - شماره حساب مقصد : {rowData.destinationAccountNo}  </text>
                                            </text>
                                            <text className={rowData.payType == 5 ? "" : 'hide'}>
                                                بانک : {rowData.bankAccount}
                                                - سریال  : {rowData.checkNo}
                                                - سر رسید : {rowData.checkDate}
                                                <text className={rowData.byCheck != "" ? "" : 'hide'}> - در وجه  : {rowData.byCheck}  </text>
                                                - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - تایید نشده" : "صیادی - تایید شده"}
                                            </text>
                                            <text className={rowData.payType == 6 ? "" : 'hide'}>
                                                صادر کننده : {rowData.recieptItem_CheckBy}
                                                <text className={rowData.recieptItem_Bank != "" ? "" : 'hide'}> - بانک  : {rowData.recieptItem_Bank}  </text>
                                                <text className={rowData.recieptItem_Branch != "" ? "" : 'hide'}> - شعبه  : {rowData.recieptItem_Branch}  </text>

                                                - سریال  : {rowData.recieptItem_CheckNo}
                                                - سر رسید : {rowData.recieptItem_CheckDate}
                                                - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - منتقل نشده" : "صیادی - منتقل شده"}
                                            </text>
                                            <text className={rowData.payType == 7 ? "" : 'hide'}>
                                                انتقال حساب به  : {rowData.accountTransfer}
                                            </text>
                                            <small className={rowData.comment != "" ? "text-muted" : 'hide'}>
                                                <br />   توضیحات : {rowData.comment}
                                            </small>
                                        </td>
                                    </tr> */}
                                </>
                            ))}
                        </tbody>
                    </table>



                </rsuite.Col>



            </rsuite.Row>
            <rsuite.Row className={localStorage.getItem("FinancialFontSize_PaymentPrint") + " p-1 "}>


                <rsuite.Col xs={24} className='ps-2 pt-3'>
                    <rsuite.Divider> خلاصه پرداخت </rsuite.Divider>

                    <rsuite.Row className='p-1 '>



                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalHavalePayment == 0 ? "hide" : 'mt-2 '}>
                            <b>مبلغ کل حواله بانکی : </b> <text>  {PN.sliceNumber(TotalHavalePayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalHavalePayment != "0" ? <>{PN.convert(TotalHavalePayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalPersonalcheckPayment == 0 ? "hide" : 'mt-2 '}>
                            <b> مبلغ کل چک شخصی : </b> <text>  {PN.sliceNumber(TotalPersonalcheckPayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalPersonalcheckPayment != "0" ? <>{PN.convert(TotalPersonalcheckPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalcheckPayment == 0 ? "hide" : 'mt-2 '}>
                            <b> مبلغ کل چک دریافتی : </b> <text>  {PN.sliceNumber(TotalcheckPayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalcheckPayment != "0" ? <>{PN.convert(TotalcheckPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalFundPayment == 0 ? "hide" : 'mt-2 '}>
                            <b> مبلغ کل صندوق : </b> <text>  {PN.sliceNumber(TotalFundPayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalFundPayment != "0" ? <>{PN.convert(TotalFundPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalAccountTransferPayment == 0 ? "hide" : 'mt-2 '}>
                            <b> مبلغ کل انتقال حساب : </b> <text>  {PN.sliceNumber(TotalAccountTransferPayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalAccountTransferPayment != "0" ? <>{PN.convert(TotalAccountTransferPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-3 text-success' >
                            <b>مبلغ کل پرداختی : </b> <text>  {PN.sliceNumber(TotalPayment)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalPayment != "0" ? <>{PN.convert(TotalPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                        </rsuite.Col>






                    </rsuite.Row>

                </rsuite.Col>




            </rsuite.Row>

            <hr />
            <rsuite.Row className={localStorage.getItem("CommentFontSize_PaymentPrint") + ' p-1  pt-3 mt-3 pb-5 mb-5 '}>
                <rsuite.Col className={localStorage.getItem("footer_PaymentPrint") != null && localStorage.getItem("footer_PaymentPrint") != "" ? "" : "hide"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div dangerouslySetInnerHTML={{ __html: localStorage.getItem("footer_PaymentPrint").replaceAll(/\//g, '<br/>') }} />

                </rsuite.Col>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'  >
                    <br />
                    <br />
                    امضا فروشنده
                    :{localStorage.getItem("UserFullName")}

                </rsuite.Col>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'  >
                    <br />
                    <br />
                    امضا طرف حساب
                    :
                </rsuite.Col>


            </rsuite.Row>






        </Layout >


    )
}

export default PrintPaymentReceivedIndex;